// Animation variants for reuse
export const fadeIn = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 }
};

export const scaleIn = {
  initial: { opacity: 0, scale: 0.95 },
  animate: { opacity: 1, scale: 1, transition: { duration: 0.15, ease: 'easeOut' } },
  exit: { opacity: 0, scale: 0.95, transition: { duration: 0.1 } }
};

export const slideUp = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.2, ease: 'easeOut' } },
  exit: { opacity: 0, y: 10, transition: { duration: 0.1 } }
};

export const slideDown = {
  initial: { opacity: 0, y: -10 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.15, ease: 'easeOut' } },
  exit: { opacity: 0, y: -10, transition: { duration: 0.1 } }
};

export const staggerContainer = {
  animate: { transition: { staggerChildren: 0.03 } }
};

export const listItem = {
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0 }
};

// CSS-in-JS animations and responsive styles
const animations = `
  @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
  @keyframes slideUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
  @keyframes slideDown { from { opacity: 0; transform: translateY(-10px); } to { opacity: 1; transform: translateY(0); } }
  @keyframes slideInRight { from { opacity: 0; transform: translateX(100%); } to { opacity: 1; transform: translateX(0); } }
  @keyframes slideInUp { from { transform: translateY(100%); } to { transform: translateY(0); } }
  @keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }
  @keyframes shimmer { 0% { background-position: -200% 0; } 100% { background-position: 200% 0; } }
  @keyframes glow { 0%, 100% { box-shadow: 0 0 5px var(--glow-color); } 50% { box-shadow: 0 0 20px var(--glow-color); } }
  @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
  @keyframes bounce { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-5px); } }
  @keyframes scaleIn { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
  @keyframes pressDown { 0% { transform: scale(1); } 50% { transform: scale(0.97); } 100% { transform: scale(1); } }
  @keyframes slideInBottom { from { transform: translateY(100%); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
  @keyframes gradientShift { 0% { background-position: 0% 50%; } 50% { background-position: 100% 50%; } 100% { background-position: 0% 50%; } }
  @keyframes lfgPulse { 0%, 100% { box-shadow: 0 4px 20px rgba(249,115,22,0.4), 0 0 30px rgba(6,182,212,0.3); } 50% { box-shadow: 0 4px 30px rgba(249,115,22,0.6), 0 0 40px rgba(6,182,212,0.5); } }

  /* Fix dropdown option styling for dark theme */
  select {
    color-scheme: dark;
  }
  select option {
    background: #12121a;
    color: #f1f5f9;
    padding: 8px;
  }
  select option:checked {
    background: #2a2a38;
  }

  /* Micro-interaction styles */
  .press-effect { transition: transform 0.1s ease, filter 0.1s ease; }
  .press-effect:active { transform: scale(0.97); }
  .hover-lift { transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.25s ease; }
  .hover-lift:hover { transform: translateY(-4px); box-shadow: 0 12px 40px rgba(0,0,0,0.35); }
  .hover-glow { transition: box-shadow 0.3s ease, border-color 0.3s ease; }
  .hover-glow:hover { box-shadow: 0 0 30px rgba(59, 130, 246, 0.3); }

  /* Glassmorphism utilities */
  .glass {
    background: rgba(18, 18, 26, 0.8);
    backdrop-filter: blur(24px) saturate(180%);
    -webkit-backdrop-filter: blur(24px) saturate(180%);
    border: 1px solid rgba(255, 255, 255, 0.08);
  }
  .glass-light {
    background: rgba(26, 26, 36, 0.65);
    backdrop-filter: blur(16px) saturate(150%);
    -webkit-backdrop-filter: blur(16px) saturate(150%);
    border: 1px solid rgba(255, 255, 255, 0.05);
  }
  .glass-card {
    background: linear-gradient(135deg, rgba(18, 18, 26, 0.9) 0%, rgba(26, 26, 36, 0.8) 100%);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.06);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.05);
  }
  .glass-card:hover {
    border-color: rgba(255, 255, 255, 0.12);
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.08);
  }

  /* Smooth button transitions */
  .btn-modern {
    transition: all 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);
    position: relative;
    overflow: hidden;
  }
  .btn-modern:hover { transform: translateY(-2px); }
  .btn-modern:active { transform: translateY(0) scale(0.98); }
  .btn-modern::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(rgba(255,255,255,0.1), transparent);
    opacity: 0;
    transition: opacity 0.2s;
  }
  .btn-modern:hover::after { opacity: 1; }

  /* Card shine effect on hover */
  .card-shine {
    position: relative;
    overflow: hidden;
  }
  .card-shine::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(
      45deg,
      transparent 40%,
      rgba(255, 255, 255, 0.03) 50%,
      transparent 60%
    );
    transform: rotate(45deg) translateX(-100%);
    transition: transform 0.6s ease;
  }
  .card-shine:hover::before {
    transform: rotate(45deg) translateX(100%);
  }

  /* Scroll snap for tabs */
  .scroll-snap-x { scroll-snap-type: x mandatory; -webkit-overflow-scrolling: touch; }
  .scroll-snap-x > * { scroll-snap-align: center; }

  /* Hide scrollbar but keep functionality */
  .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
  .hide-scrollbar::-webkit-scrollbar { display: none; }

  /* Status gradient backgrounds */
  .gradient-wtp { background: linear-gradient(135deg, #f59e0b, #d97706); }
  .gradient-played { background: linear-gradient(135deg, #10b981, #059669); }
  .gradient-never { background: linear-gradient(135deg, #ef4444, #dc2626); }

  /* Mobile bottom safe area */
  .safe-bottom { padding-bottom: env(safe-area-inset-bottom, 0); }

  /* Responsive utilities */
  @media (max-width: 768px) {
    .hide-mobile { display: none !important; }
    .show-mobile { display: flex !important; }
  }
  @media (min-width: 769px) {
    .hide-desktop { display: none !important; }
    .show-desktop { display: flex !important; }
  }
`;

// Inject animations
export function injectAnimations() {
  if (typeof document !== 'undefined' && !document.getElementById('app-animations')) {
    const style = document.createElement('style');
    style.id = 'app-animations';
    style.textContent = animations;
    document.head.appendChild(style);
  }
}

// Auto-inject on import
injectAnimations();
